import { parse } from 'marked'

import css from './ProductTip.module.css'

export default function ProductTip({ title, htmlContent }) {
    return (
        <div className={css.productTip}>
            <div className={css.background} />
            <h6>{title}</h6>
            <div dangerouslySetInnerHTML={{ __html: parse(htmlContent) }} />
        </div>
    )
}
